module.exports = __webpack_public_path__ + "static/impactjustice-c8077ef49e111633ecc17f78adb3f15d.png";